// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1oYqA","dropdown":"_2Ub3r","filterBrandsWrapper":"_1yBYm","title":"C7Vj9"};